module.exports = __webpack_public_path__ + "resources/img/img_hi_psm_m_en.7dd48914f5fcc960676980f2564c8eb2.png";